import Layout from "../../layout/main";
import CustomerService from "../../components/customerService";
/**
 * CustomerServicePage
 *
 * صفحه سرویس مشتری که بخش خدمات و پشتیبانی مشتری را نمایش می‌دهد.
 * این صفحه از Layout اصلی برای ساختار کلی استفاده می‌کند.
 *
 * ویژگی‌ها:
 * - استفاده از Layout برای حفظ یکپارچگی طراحی در سراسر اپلیکیشن
 * - نمایش کامپوننت CustomerService که اطلاعات و امکانات سرویس مشتری را ارائه می‌دهد
 *
 * @returns JSX.Element
 */
function CustomerServicePage() {
  return (
    <Layout>
      <CustomerService />
    </Layout>
  );
}

export default CustomerServicePage;
